import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59c0bfbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "account-shell"
}
const _hoisted_2 = { class: "card account-main" }
const _hoisted_3 = { class: "account-main-inner" }
const _hoisted_4 = { class: "account-avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-dot" }, null, -1))
const _hoisted_7 = { class: "account-identity" }
const _hoisted_8 = { class: "id-top" }
const _hoisted_9 = { class: "id-name" }
const _hoisted_10 = {
  key: 0,
  src: "/favicon.png",
  alt: "Elite",
  title: "Membro Elite",
  class: "elite-crown"
}
const _hoisted_11 = {
  key: 1,
  href: "/profile/billing",
  class: "chip upgrade"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right" }, null, -1))
const _hoisted_14 = { class: "id-bio" }
const _hoisted_15 = { class: "rank-block" }
const _hoisted_16 = { class: "rb-row1" }
const _hoisted_17 = { class: "kv" }
const _hoisted_18 = { class: "num" }
const _hoisted_19 = { class: "lbl" }
const _hoisted_20 = { class: "kv" }
const _hoisted_21 = { class: "num" }
const _hoisted_22 = { class: "lbl" }
const _hoisted_23 = {
  key: 0,
  class: "patent patent-right"
}
const _hoisted_24 = { class: "eyebrow" }
const _hoisted_25 = { class: "badge-ic" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "pname" }
const _hoisted_28 = { class: "rb-row2" }
const _hoisted_29 = { class: "progress-wrap" }
const _hoisted_30 = { class: "progress-head" }
const _hoisted_31 = { class: "track" }
const _hoisted_32 = {
  key: 0,
  class: "patent"
}
const _hoisted_33 = { class: "eyebrow" }
const _hoisted_34 = { class: "badge-ic" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "pname" }
const _hoisted_37 = { class: "account-metrics" }
const _hoisted_38 = { class: "metric" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cpu-fill" })
], -1))
const _hoisted_40 = { class: "num" }
const _hoisted_41 = { class: "lbl" }
const _hoisted_42 = { class: "metric" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-flag-fill" })
], -1))
const _hoisted_44 = { class: "num" }
const _hoisted_45 = { class: "lbl" }
const _hoisted_46 = { class: "metric" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-journal-bookmark-fill" })
], -1))
const _hoisted_48 = { class: "num" }
const _hoisted_49 = { class: "lbl" }
const _hoisted_50 = { class: "metric" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-collection-fill" })
], -1))
const _hoisted_52 = { class: "num" }
const _hoisted_53 = { class: "lbl" }
const _hoisted_54 = { class: "metric" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ic" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-mortarboard-fill" })
], -1))
const _hoisted_56 = { class: "num" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_58 = { class: "lbl" }
const _hoisted_59 = { class: "card account-tabs-card" }
const _hoisted_60 = { class: "account-tabs" }
const _hoisted_61 = {
  key: 1,
  class: "container text-center itens-center mb-10"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_63 = { class: "text-muted fs-3 fw-bold mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.user.avatar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.user.avatar,
                  alt: "avatar"
                }, null, 8, _hoisted_5),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.user.name), 1),
                  (_ctx.isElite)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                    : (_openBlock(), _createElementBlock("a", _hoisted_11, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.upgrade_plan`)), 1)),
                  (_ctx.user.id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: '/profile/user/' + _ctx.user.id,
                        target: "_blank",
                        class: "chip public"
                      }, [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.public_profile`)), 1)
                      ], 8, _hoisted_12))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.user.bio), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.user.score?.value ? Math.floor(_ctx.user.score.value / 1000) : 0), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.level`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString((_ctx.user.score?.value || 0).toLocaleString()), 1),
                    _createElementVNode("div", _hoisted_22, "XP · " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.experience`)), 1)
                  ]),
                  (_ctx.user.user_patent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile_public.patent`)), 1),
                        _createElementVNode("span", _hoisted_25, [
                          _createElementVNode("img", {
                            src: '/media/logos/badges/' + _ctx.user.user_patent.icon,
                            alt: ""
                          }, null, 8, _hoisted_26)
                        ]),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.user.user_patent.name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.towards_the_next_level`)), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.progressToNextLevelPercent) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", {
                        class: "fill",
                        style: _normalizeStyle('width:' + Math.min(100, _ctx.progressToNextLevelPercent) + '%')
                      }, null, 4)
                    ])
                  ]),
                  (_ctx.nextPatent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.next_rank`)), 1),
                        _createElementVNode("span", _hoisted_34, [
                          _createElementVNode("img", {
                            src: '/media/logos/badges/' + _ctx.nextPatent.icon,
                            alt: ""
                          }, null, 8, _hoisted_35)
                        ]),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.nextPatent.name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.user.machines_completed ?? 0) + "/" + _toDisplayString(_ctx.user.total_machines ?? 0), 1),
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile_public.MACHINE_PROGRESS`)), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.user.challenges_completed ?? 0) + "/" + _toDisplayString(_ctx.user.total_challenges ?? 0), 1),
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile_public.CHALLENGE_PROGRESS`)), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.user.lessons_completed ?? '—') + "/" + _toDisplayString(_ctx.user.total_lessons ?? '—'), 1),
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile_public.LESSONS_COMPLETED`)), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.user.modules_completed ?? '—') + "/" + _toDisplayString(_ctx.user.total_modules ?? '—'), 1),
              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile_public.MODULES_COMPLETED`)), 1)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("span", _hoisted_56, [
                (_ctx.user.courses_completed != null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.user.total_courses)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.user.courses_completed) + "/" + _toDisplayString(_ctx.user.total_courses), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.user.courses_completed), 1)
                          ], 64))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_57
                    ], 64))
              ]),
              _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile_public.COURSES_COMPLETED`)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_router_link, {
                to: "/profile/overview",
                class: "tab",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.overview`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/profile/settings",
                class: "tab",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.settings`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/profile/billing",
                class: "tab",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.billing`)) + " & " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.plans`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/profile/certificate",
                class: "tab",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.certificate.certificates`)), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createElementVNode("div", null, [
            _hoisted_62,
            _createElementVNode("span", _hoisted_63, "   Hacking " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)) + "...", 1)
          ])
        ])),
    _createVNode(_component_router_view)
  ], 64))
}